/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileCv = createReactComponent("file-cv", "IconFileCv", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
      key: "svg-1"
    }
  ],
  [
    "path",
    { d: "M11 12.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", key: "svg-2" }
  ],
  ["path", { d: "M13 11l1.5 6l1.5 -6", key: "svg-3" }]
]);

export { IconFileCv as default };
//# sourceMappingURL=IconFileCv.js.map
